module.exports = __webpack_public_path__ + "img/beam-body-4.be53ba94.png";